import { render, staticRenderFns } from "./RejectFileCompanyEmployee.vue?vue&type=template&id=2d3a6326&"
import script from "./RejectFileCompanyEmployee.vue?vue&type=script&lang=js&"
export * from "./RejectFileCompanyEmployee.vue?vue&type=script&lang=js&"
import style0 from "./RejectFileCompanyEmployee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports